import React from 'react';
import { TFunction } from 'i18next';
import _get from 'lodash/get';
import { CellProps, Column } from '@lib/components/Table/types';
import { ChipTypes } from '@lib/components/Chip/Chip';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import { PerformanceWidgetData } from '../PerformanceWidget';

export enum PerformanceWidgetEntityType {
  Site = 'site',
  Sector = 'sector',
}

type Args = {
  entityType: PerformanceWidgetEntityType;
  t: TFunction<'translation', undefined>;
};

const getPerformanceWidgetColumns = ({
  entityType,
  t,
}: Args): Column<PerformanceWidgetData>[] => {
  const columns: Column<PerformanceWidgetData>[] = [];

  // Entity name column (Site or Sector)
  if (entityType === PerformanceWidgetEntityType.Site) {
    columns.push({
      id: 'name',
      Header: t('site'),
      accessor: 'site',
      Cell: (props: CellProps<PerformanceWidgetData>) => {
        const label = _get(props, 'item.name', '');
        if (!label) return '-';
        return <ChipCell label={label} type={ChipTypes.chipGray} />;
      },
      sortable: true,
      maxWidth: 250,
    });
  } else if (entityType === PerformanceWidgetEntityType.Sector) {
    columns.push({
      id: 'name',
      Header: t('sector'),
      accessor: 'sector',
      Cell: (props: CellProps<PerformanceWidgetData>) => {
        const label = _get(props, 'item.name', '');
        if (!label) return '-';
        return <ChipCell label={label} type={ChipTypes.chipGray} />;
      },
      sortable: true,
      maxWidth: 250,
    });
  }

  // Deadlines missed column
  columns.push({
    id: 'totalAnomaliesByTaskDeadlinesMissed',
    Header: t('deadlines-missed'),
    accessorFn: ({ item }: CellProps<PerformanceWidgetData>) => {
      const value = _get(item, 'totalAnomaliesByTaskDeadlinesMissed');
      if (value === null || value === undefined) return '-';
      return value;
    },
    headerTooltipInfo: {
      tooltipBody: t('total-anomalies-by-task-deadlines-missed-desc'),
      icon: 'info',
      symbolsOutlined: true,
    },
    sortable: true,
    width: 120,
  });

  // Performance percentage column
  columns.push({
    id: 'successPercentageByTaskDeadlinesMissed',
    Header: t('performance-label'),
    accessorFn: ({ item }: CellProps<PerformanceWidgetData>) => {
      const val = _get(item, 'successPercentageByTaskDeadlinesMissed');
      if (val === null || val === undefined) return '-';
      if (!val) return '0';
      if (val % 1 === 0) return String(val);
      return Number(val).toFixed(2);
    },
    sortable: true,
    width: 150,
  });

  return columns;
};

export default getPerformanceWidgetColumns;
